import { post } from "./HTTPService";

export class AuthService {
  static login = (queryData = {}, config = {}) => {
    return post("/users/login/", queryData, config);
  };

  static reset = (queryData = {}, config = {}) => {
    return post("/users/reset/", queryData, config);
  };

  static resend = (queryData = {}, config = {}) => {
    return post("/users/resend/", queryData, config);
  };

  static logout = (queryData = {}, config = {}) => {
    return post("/users/login/", queryData, config);
  };
}
